import React, { FC } from "react";
import classNames from "classnames";
import { Fade } from "react-awesome-reveal";
import {
  BlockHeader,
  HeaderLevel,
} from "@app/components/common/block-header/BlockHeader";
import { TwoColumnsList } from "@app/components/base-page/models";
import { DEFAULT_FADE_DURATION } from "@app/constants";
import { LinkButtonAdapter } from "../../link-button-adapter/LinkButtonAdapter";

type Props = {
  data: TwoColumnsList;
};

export const List: FC<Props> = ({ data }) => (
  <div>
    <Fade duration={DEFAULT_FADE_DURATION} triggerOnce>
      <BlockHeader
        richText={data.title}
        headerLevel={HeaderLevel.H2}
        className={classNames(
          "text-medium mb-5",
          "lg:mb-9",
          "xl:text-large xl:mb-8",
        )}
      />
      {data.items.map((row, i) => (
        <div
          key={row._uid}
          className={classNames(
            "border-divider flex flex-col py-5",
            "md:flex-row md:justify-between md:gap-x-10",
            "lg:py-6",
            "xl:py-7",
            {
              "border-t": i !== 0,
            },
          )}
        >
          <div
            className={classNames(
              "text-extra-small text-base-400",
              "md:flex-1",
              "lg:text-regular",
              "xl:w-[64%] xl:flex-none",
            )}
          >
            {row.name}
          </div>
          <div
            className={classNames(
              "text-extra-small",
              "md:flex-1 md:text-end",
              "lg:text-regular",
              "xl:w-[32%] xl:flex-none xl:text-start",
            )}
          >
            {row.button?.length ? (
              <LinkButtonAdapter data={row.button[0]} />
            ) : (
              row.value
            )}
          </div>
        </div>
      ))}
      {data.footnote && (
        <p
          className={classNames(
            "border-divider text-extra-small text-base-400 border-t pt-5",
            "lg:pt-6",
            "xl:pt-7",
          )}
        >
          {data.footnote}
        </p>
      )}
    </Fade>
  </div>
);
